/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const ClassSignupEligibilityStatus = {
  Ineligible: "INELIGIBLE",
  Eligible: "ELIGIBLE",
  Enrolled: "ENROLLED",
  PurchaseHold: "PURCHASE_HOLD",
  Waitlisted: "WAITLISTED",
  WaitlistedPending: "WAITLISTED_PENDING",
} as const;

export type ClassSignupEligibilityStatus =
  (typeof ClassSignupEligibilityStatus)[keyof typeof ClassSignupEligibilityStatus];

export type ClassSignupEligibilityStatusEnumType =
  typeof ClassSignupEligibilityStatus;
export type ClassSignupEligibilityStatusOptional = ClassSignupEligibilityStatus;
export type ClassSignupEligibilityStatusTrackedI = ClassSignupEligibilityStatus;
export type ClassSignupEligibilityStatusTracked = ClassSignupEligibilityStatus;
export type ClassSignupEligibilityStatusMetaI = EnumMetaType<
  ClassSignupEligibilityStatusEnumType,
  ClassSignupEligibilityStatus
>;
export const ClassSignupEligibilityStatusMeta = typeMetaEnum<
  ClassSignupEligibilityStatusEnumType,
  ClassSignupEligibilityStatus
>("ClassSignupEligibilityStatus", ClassSignupEligibilityStatus);
export function transformDatesClassSignupEligibilityStatus(
  model: ClassSignupEligibilityStatus,
) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
